export default __webpack_public_path__ + "static/media/solitaire.b34f70bd.webp";